export default () => $(`
<div class="wrapper wrapper-content" id="hotelf-main-content-area">
  <div class="row">
    <div class="col-lg-9">
      <div class="ibox" id="booking_summary_main">
        <div class="ibox-content">
          <div class="row">
            <div class="col-lg-12">
              <div class="m-b-md">
                <h2><span class="placeholder-strong">############################</span></h2>
              </div>
              <dl class="dl-horizontal">
                <dt><span class="placeholder">Estado:</span></dt>
                <dd><span class="placeholder">Previsto</span></dd>
              </dl>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-5">
              <dl class="dl-horizontal">
                <dt class="edit_hover_class"><span class="placeholder"><a href="#">Cliente</a></span></dt>
                <dd><span class="placeholder"><a href="#">####### ######</a></span></dd>
                <dt class="edit_hover_class"><span class="placeholder"><a href="#">Empresa</a></span></dt>
                <dd></dd>
                <dt class="edit_hover_class"><span class="placeholder"><a href="#">Pessoas</a></span></dt>
                <dd> <span class="placeholder">#</span></dd>
                <dt class="edit_hover_class"><span class="placeholder"><a href="#">Adultos</a></span></dt>
                <dd><span class="placeholder">#</span></dd>
                <dt class="edit_hover_class"><span class="placeholder"><a href="#">Crianças</a></span></dt>
                <dd><span class="placeholder">#</span></dd>
              </dl>
            </div>
            <div class="col-lg-7" id="cluster_info">
              <dl class="dl-horizontal">
                <dt class="edit_hover_class"><span class="placeholder"><a href="#">Apartamento</a></span></dt>
                <dd><span class="placeholder"><a href="#">#############</a></span></dd>
                <dt class="edit_hover_class"><span class="placeholder"><a href="#">Entrada Prevista</a></span></dt>
                <dd> <span class="placeholder">## ## ##### ## ####</span></dd>
                <dt class="edit_hover_class"><span class="placeholder"><a href="#">Saída Prevista</a></span></dt>
                <dd> <span class="placeholder">## ## ##### ## ####</span></dd>
                <dt> <span class="placeholder">Diárias</span></dt>
                <dd> <span class="placeholder">#</span></dd>
              </dl>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <table class="table" id="booking_summary_tabela_pagamentos">
                <thead>
                  <tr>
                    <th colspan="3"> <span class="placeholder-strong">Pagamentos</span></th>
                    <th class="min-width"><span class="placeholder">Valor</span></th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
              <table class="table" id="booking_summary_tabela_despesas">
                <thead>
                  <tr>
                    <th><span class="placeholder">Despesas</span></th>
                    <th class="min-width"><span class="placeholder">qtd</span></th>
                    <th class="min-width"><span class="placeholder">Unitário</span></th>
                    <th class="min-width"><span class="placeholder">Total</span></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><span class="placeholder-strong">Despesas com Diárias</span></td>
                  </tr>
                  <tr class="total">
                    <td></td>
                    <td class="min-width" colspan="2">
                      <span class="placeholder">Total</span>
                    </td>
                    <td class="min-width">
                      <span class="placeholder">#########</span>
                    </td>
                  </tr>
                  <tr class="pending_balance">
                    <td></td>
                    <td class="min-width" colspan="2">
                      <span class="placeholder">Saldo devedor</span>
                    </td>
                    <td class="min-width">
                      <span class="placeholder">#########</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-3" id="booking_summary_sidebar">
      <h4 class="edit_hover_class"><span class="placeholder-strong"><a href="#">Acompanhantes</a></span></h4>
      <div class="space-16"></div>
      <h4 class="edit_hover_class"><span class="placeholder"> <a href="#">Veículos</a></span></h4>
      <div class="space-16"></div>
      <h4> <span class="placeholder-strong">Registro de Horários</span></h4>
      <p> <span class="placeholder">Reserva</span><span class="pull-right"><span class="placeholder">#################</span></span></p>
      <p><span class="placeholder">Entrada</span><span class="pull-right"></span></p>
      <p><span class="placeholder"> Saída</span><span class="pull-right"></span></p>
    </div>
  </div>
</div>`)